import { Reservation } from "@glidevvr/reservation-app";
import "@glidevvr/reservation-app/styles.css";
import type { RootState } from "@/store";
import { useSelector } from "react-redux";
import { FunnelType } from "@/types/enums";
import { useUnitItemContext } from "@/hooks/useUnitItemContext";
import { ReservationType } from "@/types/enums";

interface UnitFunnelProps {
    type: string;
    selectedUnitId: number | string;
}
export const UnitFunnel = ({ selectedUnitId }: UnitFunnelProps) => {
    const { unitGroup: selectedUnitGroup, selectedPromo } =
        useUnitItemContext();

    const { funnelType } = useSelector((state: RootState) => state.journey);
    const apiKey = useSelector((state: RootState) => state.apiKey.apiKey);

    const isQuote = funnelType === FunnelType.QUOTE;
    const showRentalFunnel = funnelType === FunnelType.RENT;
    const showReservationFunnel =
        funnelType === FunnelType.RESERVE || isQuote;

    return (
        <div>
            {showRentalFunnel && (
                <div
                    className="rental-funnel-root"
                    id={`unitFunnel${selectedUnitId}`}
                >
                    Funnel to Attach Here
                </div>
            )}
            {showReservationFunnel && (
                <Reservation
                    apiKey={apiKey}
                    environment={import.meta.env.VITE_SE_ENVIRONMENT}
                    facilityId={
                        selectedUnitGroup.representative_unit.facility_id
                    }
                    unitId={Number(selectedUnitId)}
                    promotionId={Number(selectedPromo)}
                    reservationType={isQuote ? ReservationType.SOFT : ReservationType.HARD}
                    showDetails={false}
                    leadMode={isQuote}
                />
            )}
        </div>
    );
};
